<script>

    import { scaleDiverging, interpolateRdYlBu } from 'd3';

    // Match the chart's color encoding (RdYlBu diverging on RONI)
    const colorScale = scaleDiverging([2.5, 0, -2.5], interpolateRdYlBu);

    // Ordered as a number line: strongest La Niña -> weak -> weak -> strongest El Niño
    const groups = [
        {
            phase: 'La Niña',
            swatch: colorScale(-1.5),
            items: [
                { value: -2,   strength: 'Very Strong' },
                { value: -1.5, strength: 'Strong' },
                { value: -1,   strength: 'Moderate' },
                { value: -0.5, strength: 'Weak' },
            ],
        },
        {
            phase: 'El Niño',
            swatch: colorScale(1.5),
            items: [
                { value: 0.5, strength: 'Weak' },
                { value: 1,   strength: 'Moderate' },
                { value: 1.5, strength: 'Strong' },
                { value: 2,   strength: 'Very Strong' },
            ],
        },
    ];

</script>

<p class="data-label">Oceanic Niño Index</p>
<div class="legend">
    {#each groups as group, gi}
        <div class="group {group.phase === 'El Niño' ? 'nino' : 'nina'}">
            <div class="phase" style="color:{group.swatch}">{group.phase}</div>
            <div class="items">
                {#each group.items as item, ii}
                    <div class="item">
                        <span
                            class="swatch"
                            class:round-left={gi === 0 && ii === 0}
                            class:round-right={gi === groups.length - 1 && ii === group.items.length - 1}
                            style="background:{colorScale(item.value)}"
                        ></span>
                        <span class="strength">{item.strength}</span>
                        <span class="value">{item.value > 0 ? '+' : ''}{item.value}&deg;C</span>
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>

<style lang='scss'>
    .data-label {
        font-family: $sans-serif;
        font-weight: 500;
        font-size: 14px;
        margin: 0.5rem 0 0.35rem;
    }
    .legend {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 1.5rem;
        margin: 0 0 1rem;
        font-family: $sans-serif;
    }

    // On mobile, surface El Niño first and tighten the vertical gap when stacked
    @media #{$mobile} {
        .legend { row-gap: 0.35rem; }
        .group.nino { order: -1; }
    }
    .phase {
        font-size: 12px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 4px;
    }
    .items {
        display: flex;
    }
    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 62px;
        text-align: center;
    }
    .swatch {
        width: 100%;
        height: 8px;
        display: block;

        &.round-left {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        &.round-right {
            border-top-right-radius: 5px;
            border-bottom-right-radius:5px;
        }
    }
    .strength {
        font-size: 10px;
        color: $gray9;
        margin-top: 4px;
        line-height: 1.2;
    }
    .value {
        font-size: 10px;
        color: $gray7;
    }
</style>
